export const TAB_NAVIGATION_TEST_IDS = {
  actions: 'tab-navigation__actions',
  item: (value: string) => `tab-navigation__item-${value}`,
  items: 'tab-navigation__items',
  itemsScrollLeft: 'tab-navigation__items-scroll-left',
  itemsScrollRight: 'tab-navigation__items-scroll-right',
  root: 'tab-navigation',
};
